// extracted by mini-css-extract-plugin
export var Section = "Location-module--Section--JA9Iz";
export var LangHY = "Location-module--LangHY--VS9nW";
export var Text = "Location-module--Text--0TOBt";
export var Inner = "Location-module--Inner--DvwNs";
export var arrowLeft = "Location-module--arrowLeft--CkZZ5";
export var arrowRight = "Location-module--arrowRight--4Lx64";